export interface FeeType {
  name: string;
  description?: string;
}

export interface Fee {
  id: string | number;
  name: string;
  type?: FeeType;
  discountValue: number;
  isTaxable: boolean;
  validFromDate?: Date;
  validToDate?: Date;
  additionalDescription?: string;
  description?: string;
}

export interface Currency {
  symbol: string;
  isBaseCurrency: boolean;
} 
export enum FeeOrDiscountContext {
  LINE = 'line',
  FOOTER = 'footer',
}

export enum DialogTypeFeeOrDiscount {
  HANDLING_FEE = 'handlingFee',
  DISCOUNT = 'discount',
}
export interface FeeOrDiscount {
  discountValue: number;
  discountCategoryId: number;
}
